// extracted by mini-css-extract-plugin
export default {"columns":"SupportSectionTablet_columns__KQgp2","column":"SupportSectionTablet_column__hntlh","title":"SupportSectionTablet_title__tWJJC"};